import socketIOClient from 'socket.io-client';
import isEmpty from 'lodash/isEmpty';

import * as actionTypes from './actiontypes';
import { SOCKET_EVENTS } from '../../config/constants';
import { showMessage, getAuthSocketData, log } from '../../config/utils';
import * as URLS from '../../config/urls';

export function updateDashboardState(payload, path) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.UPDATE_DASHBOARD_STATE,
      payload,
      path
    });
  };
}

export function registerDashboardSocketListener() {
  return (dispatch) => {
    const AUTH_SOCKET_DATA = getAuthSocketData();
    const socket = socketIOClient.connect(URLS.SOCKET_URLS.LIVE_STATISTICS_SOCKET_URL, AUTH_SOCKET_DATA);

    socket.on(SOCKET_EVENTS.CONNECT, () => {
      dispatch({
        type: actionTypes.DASHBOARD_SOCKET_CONNECTED,
        payload: socket
      });
    });

    socket.on(SOCKET_EVENTS.CONNECT_ERROR, () => {
      dispatch({
        type: actionTypes.DASHBOARD_SOCKET_CONNECT_ERROR
      });
    });

    socket.on(SOCKET_EVENTS.ERROR, (err) => {
      log('socket error', err);
      showMessage('error', 'connection error...');
      dispatch({
        type: actionTypes.DASHBOARD_SOCKET_ERROR,
      });
    });

    socket.on(SOCKET_EVENTS.RECONNECT, (data) => {
      log('dashboard socket reconnect', data);
      showMessage('warning', 'dashboard socket reconnected');
    });

    socket.on(SOCKET_EVENTS.RECONNECTING, (attemptNum) => {
      log('dashboard socket reconnecting', attemptNum);
    });

    socket.on(SOCKET_EVENTS.RECONNECT_ERROR, (error) => {
      log('dashboard socket reconnect error', error);
    });

    socket.on(SOCKET_EVENTS.DISCONNECT, (data) => {
      log('dashboard socket disconnect', data);
      if (data === 'io server disconnect') {
        showMessage('warning', 'dashboard socket disconnected');
      }
    });

    socket.on(SOCKET_EVENTS.PER_SECOND_STATS, response => {
      if (response && response.liveCount && !isEmpty(response.liveCount)) {
        dispatch({
          type: actionTypes.LIVE_COUNT_PER_SEC,
          payload: response.liveCount
        });
      }
    });

    socket.on(SOCKET_EVENTS.LAST_N_HOURS_TIME_SERIES, (response) => {
      if (response && response.timeSeries && !isEmpty(response.timeSeries)) {
        dispatch({
          type: actionTypes.LAST_N_HOURS_TIME_SERIES,
          payload: response.timeSeries
        });
      }
    });

    socket.on(SOCKET_EVENTS.PER_MINUTE_STATS, (response) => {
      if (response && response.liveCount && !isEmpty(response.liveCount)) {
        dispatch({
          type: actionTypes.LIVE_COUNT_PER_MIN,
          payload: response.liveCount
        });
      }
    });
  };
}

export function updateScalePerMin(payload) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.UPDATE_SCALE_PER_MIN,
      payload,
    });
  }
}



// WEBPACK FOOTER //
// ./src/data/redux/dashboard_details/actions.js